module.exports = __webpack_public_path__ + "static/media/hourglass_red_fulla04b225bdc41f4bbb632e046f55f7d5c.webp";